import styled from 'styled-components';
import { colorYellow } from 'styleUtils';
import Icon from 'components/Icon';
export var Wrapper = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-5piwbr-0"
})(["align-items:flex-start;display:inline-flex;position:relative;"]);
export var List = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-5piwbr-1"
})(["align-items:center;display:inline-flex;&:first-child{left:0;overflow:hidden;position:absolute;top:0;}"]);
export var StarIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-5piwbr-2"
})(["height:13px;fill:none;width:12.75px;min-width:12.75px;stroke:", ";&[data-filled='true']{fill:", ";}&:not(:last-child){margin-right:0.75px;}"], colorYellow, colorYellow);